/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon20Light = forwardRef('ArrowDCornerUpLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.146 1.646a.5.5 0 1 1 .708.708L3.207 7H14a3 3 0 0 1 3 3v8.5a.5.5 0 1 1-1 0V10a2 2 0 0 0-2-2H3.207l4.647 4.646a.5.5 0 0 1-.708.708L2.495 8.702a1.7 1.7 0 0 1 0-2.404l4.651-4.652Z" })));
});
